import { authenticatedFetch } from '../utils/fetchUtils';

const BASE_URL = (process.env.REACT_APP_API_BASE_URL || (typeof window !== 'undefined' ? window.location.origin : '')) + '/api/blogs';

const parseErrorMessage = async (response, fallback) => {
  const text = await response.text();
  try {
    const errorData = JSON.parse(text);
    return errorData.message || fallback;
  } catch {
    return `Server error (${response.status})`;
  }
};

// Public — no auth required.
export const getBlogs = async (page = 1, limit = 12) => {
  const response = await fetch(`${BASE_URL}?page=${page}&limit=${limit}`);
  if (!response.ok) throw new Error(await parseErrorMessage(response, 'Failed to fetch blogs'));
  return await response.json();
};

export const getLatestBlogs = async (limit = 3) => {
  const response = await fetch(`${BASE_URL}/latest?limit=${limit}`);
  if (!response.ok) throw new Error(await parseErrorMessage(response, 'Failed to fetch latest blogs'));
  const data = await response.json();
  return data.blogs || [];
};

export const getBlogBySlug = async (slug) => {
  const response = await fetch(`${BASE_URL}/${encodeURIComponent(slug)}`);
  if (!response.ok) throw new Error(await parseErrorMessage(response, 'Blog not found'));
  const data = await response.json();
  return data.blog;
};

// blogAdmin / admin only — auth required.
export const getAllBlogsAdmin = async (page = 1, limit = 20) => {
  const response = await authenticatedFetch(`${BASE_URL}/admin/all?page=${page}&limit=${limit}`);
  if (!response.ok) throw new Error(await parseErrorMessage(response, 'Failed to fetch blogs'));
  return await response.json();
};

export const getBlogByIdAdmin = async (id) => {
  const response = await authenticatedFetch(`${BASE_URL}/admin/${encodeURIComponent(id)}`);
  if (!response.ok) throw new Error(await parseErrorMessage(response, 'Blog not found'));
  const data = await response.json();
  return data.blog;
};

export const createBlog = async (data) => {
  const response = await authenticatedFetch(BASE_URL, {
    method: 'POST',
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error(await parseErrorMessage(response, 'Failed to create blog'));
  const result = await response.json();
  return result.blog;
};

export const updateBlog = async (id, data) => {
  const response = await authenticatedFetch(`${BASE_URL}/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error(await parseErrorMessage(response, 'Failed to update blog'));
  const result = await response.json();
  return result.blog;
};

export const deleteBlog = async (id) => {
  const response = await authenticatedFetch(`${BASE_URL}/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
  if (!response.ok) throw new Error(await parseErrorMessage(response, 'Failed to delete blog'));
  return await response.json();
};
